// Module
var code = `<section class="page-body default-content">

  <h2>Tables</h2>
  <p>
    Tables are used to display structured data in rows and columns.
    SpyneJS applies consistent spacing, borders, and typography to ensure
    tables are legible and theme-aware.
  </p>

  <!-- Basic Table -->
  <h3>Basic Table</h3>
  <p>
    A table with header and body rows styled using the design system’s variables.
  </p>
  <div class="table-examples">
    <table class="table">
      <thead>
      <tr>
        <th>Item</th>
        <th>Quantity</th>
        <th>Price</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Apples</td>
        <td>3</td>
        <td>\$2.50</td>
      </tr>
      <tr>
        <td>Bananas</td>
        <td>6</td>
        <td>\$4.00</td>
      </tr>
      <tr>
        <td>Cherries</td>
        <td>10</td>
        <td>\$7.50</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;table class="table"&gt;
  &lt;thead&gt;
    &lt;tr&gt;
      &lt;th&gt;Item&lt;/th&gt;
      &lt;th&gt;Quantity&lt;/th&gt;
      &lt;th&gt;Price&lt;/th&gt;
    &lt;/tr&gt;
  &lt;/thead&gt;
  &lt;tbody&gt;
    &lt;tr&gt;
      &lt;td&gt;Apples&lt;/td&gt;
      &lt;td&gt;3&lt;/td&gt;
      &lt;td&gt;\$2.50&lt;/td&gt;
    &lt;/tr&gt;
    &lt;tr&gt;
      &lt;td&gt;Bananas&lt;/td&gt;
      &lt;td&gt;6&lt;/td&gt;
      &lt;td&gt;\$4.00&lt;/td&gt;
    &lt;/tr&gt;
    &lt;tr&gt;
      &lt;td&gt;Cherries&lt;/td&gt;
      &lt;td&gt;10&lt;/td&gt;
      &lt;td&gt;\$7.50&lt;/td&gt;
    &lt;/tr&gt;
  &lt;/tbody&gt;
&lt;/table&gt;
    </code></pre>
  </div>

  <!-- Striped Rows -->
  <h3>Striped Rows</h3>
  <p>
    Alternate rows are automatically shaded using <code>:nth-child(even)</code>
    for improved readability.
  </p>
  <div class="table-examples">
    <table class="table">
      <thead>
      <tr>
        <th>Name</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Alice</td>
        <td>Active</td>
      </tr>
      <tr>
        <td>Bob</td>
        <td>Inactive</td>
      </tr>
      <tr>
        <td>Charlie</td>
        <td>Active</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;table class="table"&gt;
  &lt;thead&gt;
    &lt;tr&gt;&lt;th&gt;Name&lt;/th&gt;&lt;th&gt;Status&lt;/th&gt;&lt;/tr&gt;
  &lt;/thead&gt;
  &lt;tbody&gt;
    &lt;tr&gt;&lt;td&gt;Alice&lt;/td&gt;&lt;td&gt;Active&lt;/td&gt;&lt;/tr&gt;
    &lt;tr&gt;&lt;td&gt;Bob&lt;/td&gt;&lt;td&gt;Inactive&lt;/td&gt;&lt;/tr&gt;
    &lt;tr&gt;&lt;td&gt;Charlie&lt;/td&gt;&lt;td&gt;Active&lt;/td&gt;&lt;/tr&gt;
  &lt;/tbody&gt;
&lt;/table&gt;
    </code></pre>
  </div>

  <!-- Hover Rows -->
  <h3>Hover Rows</h3>
  <p>
    Rows are highlighted on hover, providing visual feedback when scanning or selecting data.
  </p>
  <div class="table-examples">
    <table class="table">
      <thead>
      <tr>
        <th>Project</th>
        <th>Owner</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Website Redesign</td>
        <td>Sara</td>
      </tr>
      <tr>
        <td>Mobile App</td>
        <td>John</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;table class="table"&gt;
  &lt;thead&gt;
    &lt;tr&gt;&lt;th&gt;Project&lt;/th&gt;&lt;th&gt;Owner&lt;/th&gt;&lt;/tr&gt;
  &lt;/thead&gt;
  &lt;tbody&gt;
    &lt;tr&gt;&lt;td&gt;Website Redesign&lt;/td&gt;&lt;td&gt;Sara&lt;/td&gt;&lt;/tr&gt;
    &lt;tr&gt;&lt;td&gt;Mobile App&lt;/td&gt;&lt;td&gt;John&lt;/td&gt;&lt;/tr&gt;
  &lt;/tbody&gt;
&lt;/table&gt;
    </code></pre>
  </div>

  <!-- Prefixed Tables -->
  <h3>Prefixed Tables (Plugins)</h3>
  <p>
    Plugins can scope tables using prefixed classes (e.g. <code>.devtool-table</code>)
    to avoid style collisions with the host application.
  </p>
  <div class="table-examples">
    <table class="devtool-table">
      <thead>
      <tr>
        <th>Plugin Data</th>
        <th>Value</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Alpha</td>
        <td>123</td>
      </tr>
      <tr>
        <td>Beta</td>
        <td>456</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;table class="devtool-table"&gt;
  &lt;thead&gt;
    &lt;tr&gt;&lt;th&gt;Plugin Data&lt;/th&gt;&lt;th&gt;Value&lt;/th&gt;&lt;/tr&gt;
  &lt;/thead&gt;
  &lt;tbody&gt;
    &lt;tr&gt;&lt;td&gt;Alpha&lt;/td&gt;&lt;td&gt;123&lt;/td&gt;&lt;/tr&gt;
    &lt;tr&gt;&lt;td&gt;Beta&lt;/td&gt;&lt;td&gt;456&lt;/td&gt;&lt;/tr&gt;
  &lt;/tbody&gt;
&lt;/table&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Always include <code>&lt;thead&gt;</code> with <code>&lt;th&gt;</code> elements to label columns.</li>
    <li>Use semantic HTML — avoid building tables from divs.</li>
    <li>Ensure sufficient contrast for table borders and row shading.</li>
    <li>Provide captions (<code>&lt;caption&gt;</code>) for context where appropriate.</li>
  </ul>

</section>
`;
// Exports
module.exports = code;